import { z } from "zod"

const session = z.object({
  provider_id: z.string(), status: z.string(),
  data: z.record(z.string(), z.unknown()).nullish(),
})
const collection = z.object({
  id: z.string(), status: z.string().optional(),
  payment_sessions: z.array(session).optional(),
})
export const webpayValidationCollectionSchema = z.object({ payment_collection: collection })
export const webpayValidationCartSchema = z.object({ cart: z.object({
  id: z.string(), sales_channel_id: z.string(), total: z.number(), currency_code: z.string(),
  completed_at: z.string().nullish(),
  items: z.array(z.object({ variant_id: z.string(), quantity: z.number() })),
  payment_collection: collection.nullish(),
}) })
